import { resolvePlanType } from "Helpers/misc";

/**
 * @typedef { Object } PlanTypeData
 * @property { string|null } original The original plan type for the current customer.
 * @property { string|undefined } override The current plan type override.
 * @property { string|undefined } expires The datetime when the override will expire in the session.
 */

export default {
  data: () => ({
    selected_plan_type: null,
    plan_types: [
      'podcaster',
      'broadcaster',
    ],
  }),
  computed: {
    /**
     * Gets the currently active plan type, which is either the customer's plan type or an override (see `plan_type_data`).
     *
     * @return { string }
     */
    current_plan_type() {
      return resolvePlanType();
    },
    /**
     * Gets the plan type data from the `window`.
     *
     * @return { PlanTypeData }
     */
    plan_type_data() {
      return window.plan_type_data;
    },
  },
  methods: {
    /**
     * POSTs `this.selected_plan_type` to the API, locally overriding it (against the session).
     */
    async overridePlanType() {
      try {
        const response = (await axios.post(`/admin/tools/override-plan-type/${this.selected_plan_type}`)).data;
        if (response.success) {
          if (response.data.message) {
            toastr.success("Selected plan type matches customer's current plan type (overrides cleared)");
          } else {
            toastr.success('Plan type locally overridden');
          }
        }
      } catch (err) {
        window.handleAxiosError(err);
      }
    },
    /**
     * Sets `this.selected_plan_type` to `selected_plan`.
     *
     * Returns the selected plan type.
     *
     * @param { string | { plan_type: string } } selected_plan Either a plan type (as a `string`) or a plan object with a `.plan_type` field.
     * @return string
     */
    selectPlanType(selected_plan) {
      if (selected_plan) {
        // select the plan type from the plan
        this.selected_plan_type = typeof selected_plan === 'string' ? selected_plan : selected_plan.plan_type;
      } else {
        this.selected_plan_type = null;
      }

      return this.selected_plan_type;
    },
  },
};
